import VueFormulate from "@braid/vue-formulate";
import FormulateVueDatetimePlugin from "@cone2875/vue-formulate-datetime";
import "@sum.cumo/vue-datepicker/dist/Datepicker.css";
import attachCognitoModule from "@vuetify/vuex-cognito-module";
import Vue from "vue";
import "vue-datetime/dist/vue-datetime.css";
import VueFormulateDatepickerPlugin from "vue-formulate-datepicker";
import "../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
import App from "./App.vue";
import "./plugins/vuelidate";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

// https://cli.vuejs.org/guide/mode-and-env.html#environment-variables
attachCognitoModule(
  store,
  {
    userPoolId: process.env.VUE_APP_AWS_USERPOOL_ID,
    identityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID, // This field is now optional
    userPoolWebClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    region: process.env.VUE_APP_AWS_REGION
  },
  "cognito"
);

Vue.config.productionTip = false;
Vue.use(VueFormulate, {
  plugins: [FormulateVueDatetimePlugin, VueFormulateDatepickerPlugin]
});
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");

/*
// Add authentication token to each request
axios.interceptors.request.use(async config => {
  const response = await store.dispatch('getUserSession');
  if (response && response.accessToken && response.accessToken.jwtToken) {
    config.headers.AccessToken = response.accessToken.jwtToken;
  }
  return config;
});
*/
